import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingTopics = ({ topics, onTopicClick }) => {
  const getTrendingIcon = (trend) => {
    if (trend > 50) return { icon: 'TrendingUp', color: 'text-success-500' };
    if (trend > 0) return { icon: 'TrendingUp', color: 'text-warning-500' };
    return { icon: 'TrendingDown', color: 'text-error-500' };
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-lg text-accent-800">Trending Topics</h3>
        <Icon name="TrendingUp" size={20} className="text-primary" />
      </div>
      
      <div className="space-y-3">
        {topics.map((topic, index) => {
          const trendingData = getTrendingIcon(topic.trend);
          
          return (
            <button
              key={topic.id}
              onClick={() => onTopicClick(topic)}
              className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-surface transition-colors duration-200 group"
            >
              <div className="flex items-center space-x-3">
                <span className="text-sm font-bold text-accent-400 min-w-6">
                  {index + 1}
                </span>
                <div>
                  <h4 className="font-medium text-accent-800 group-hover:text-primary transition-colors">
                    #{topic.hashtag}
                  </h4>
                  <p className="text-sm text-accent-500">
                    {topic.postsCount} posts
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <Icon 
                  name={trendingData.icon} 
                  size={16} 
                  className={trendingData.color}
                />
                <span className={`text-sm font-medium ${trendingData.color}`}>
                  {topic.trend > 0 ? '+' : ''}{topic.trend}%
                </span>
              </div>
            </button>
          );
        })}
      </div>
      
      <button className="w-full mt-4 p-3 text-center text-primary font-medium hover:bg-primary-50 rounded-xl transition-colors duration-200">
        View All Trending
      </button>
    </div>
  );
};

export default TrendingTopics;